export default function getOnlyDigits(value, onlyDigits) {
  const reg = onlyDigits ? /[^0-9]/g : /[^0-9.]/g;
  return String(value).replace(reg, '');
}
